module.exports = __webpack_public_path__ + "img/gpy3.f4a1ba69.png";